module.exports = __webpack_public_path__ + "static/media/map-marker-grey.b3dfc52c.svg";